export function backToTop() {
  return window.scrollTo({
    top: 0,
    behavior: "instant", // smooth scrolling
  });
}
